// app.tsx — the embedded nav menu (<ui-nav-menu>) + its in-app ErrorBoundary.
export const nav = {
  menu: {
    home: "Home",
    guide: "Guide",
    quotes: "Quotes",
    poInbox: "PO Inbox",
    companies: "Companies",
    priceLists: "Price lists",
    aiAssistant: "AI Assistant",
    settings: "Settings",
    sendFeedback: "Send feedback",
  },
  errorBoundary: {
    notFoundHeadline: "Page not found",
    sessionExpiredHeadline: "Session expired",
    genericHeadline: "Something broke",
    notFoundBody: "The page you were looking for doesn't exist or you don't have access.",
    sessionExpiredBody: "Please reload the page to sign in again.",
    genericBody: "Try again in a moment, or contact support if it keeps happening.",
    backToDashboard: "Back to dashboard",
    quotes: "Quotes",
    companies: "Companies",
  },
};
